<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  referral: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const hasImage = computed(
  () => props.referral.media_type === 'image' && props.referral.image_url
);

const isAd = computed(() =>
  ['ad', 'AD'].includes(props.referral.source_type)
);
</script>

<template>
  <a
    v-if="referral.source_url"
    :href="referral.source_url"
    target="_blank"
    rel="noopener noreferrer"
    class="flex gap-3 rounded-lg border border-n-weak bg-n-alpha-1 p-3 no-underline hover:bg-n-alpha-2 transition-colors"
  >
    <img
      v-if="hasImage"
      :src="referral.image_url"
      :alt="referral.headline"
      class="h-14 w-14 shrink-0 rounded-md object-cover"
    />
    <div class="min-w-0 flex-1">
      <div class="mb-1 flex items-center gap-1.5">
        <span class="text-[10px] font-semibold uppercase tracking-wide text-n-slate-11">
          {{ isAd ? t('COMPONENTS.CTWA_BUBBLE.SPONSORED') : t('COMPONENTS.CTWA_BUBBLE.AD_LABEL') }}
        </span>
        <Icon icon="i-lucide-badge-check" class="size-3 text-n-slate-11" />
      </div>
      <p v-if="referral.headline" class="mb-0.5 truncate text-sm font-medium text-n-slate-12 leading-tight">
        {{ referral.headline }}
      </p>
      <p v-if="referral.body" class="mb-0 line-clamp-2 text-xs text-n-slate-11 leading-snug">
        {{ referral.body }}
      </p>
    </div>
    <Icon icon="i-lucide-external-link" class="mt-0.5 size-3.5 shrink-0 text-n-slate-11" />
  </a>
  <div
    v-else
    class="flex gap-3 rounded-lg border border-n-weak bg-n-alpha-1 p-3"
  >
    <img
      v-if="hasImage"
      :src="referral.image_url"
      :alt="referral.headline"
      class="h-14 w-14 shrink-0 rounded-md object-cover"
    />
    <div class="min-w-0 flex-1">
      <div class="mb-1 flex items-center gap-1.5">
        <span class="text-[10px] font-semibold uppercase tracking-wide text-n-slate-11">
          {{ isAd ? t('COMPONENTS.CTWA_BUBBLE.SPONSORED') : t('COMPONENTS.CTWA_BUBBLE.AD_LABEL') }}
        </span>
        <Icon icon="i-lucide-badge-check" class="size-3 text-n-slate-11" />
      </div>
      <p v-if="referral.headline" class="mb-0.5 truncate text-sm font-medium text-n-slate-12 leading-tight">
        {{ referral.headline }}
      </p>
      <p v-if="referral.body" class="mb-0 line-clamp-2 text-xs text-n-slate-11 leading-snug">
        {{ referral.body }}
      </p>
    </div>
  </div>
</template>
